<div class="snackbar-wrapper">
  <mat-icon class="snackbar-icon" [ngStyle]="{color: data.color}">
    {{ data.icon || 'check_circle' }}
  </mat-icon>
  <div class="snackbar-content">
    <div class="snackbar-title" [ngStyle]="{'color':data.color}">{{data.title }}</div>
    <div class="snackbar-message" *ngIf="data.message">{{ data.message }}</div>
  </div>
  <button mat-icon-button matSnackBarDismiss (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="progress-bar" [ngStyle]="{'background-color': data.color, 'animation-duration': (data.duration || 3000) + 'ms'}"></div>

